import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "opModal p-3" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "control-label" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "control-label" }
const _hoisted_6 = { class: "form-group text-center" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "text-center"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "form-group text-center" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "control-label" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_file_dropper = _resolveComponent("file-dropper")!
  const _component_tiny_editor = _resolveComponent("tiny-editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Titolo",
          text: "Titolo"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content.title) = $event))
      }, null, 512), [
        [_vModelText, _ctx.content.title]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _createVNode(_component_localized_text, {
          localizedKey: "Sottotitolo",
          text: "Sottotitolo"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.content.subTitle) = $event))
      }, null, 512), [
        [_vModelText, _ctx.content.subTitle]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Video (viene caricato su S3)",
          text: "Video (viene caricato su S3)"
        })
      ]),
      (!_ctx.preview)
        ? (_openBlock(), _createBlock(_component_file_dropper, {
            key: 0,
            modelValue: _ctx.fileToUpload,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fileToUpload) = $event))
          }, null, 8, ["modelValue"]))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: _ctx.content.url,
            target: "_blank",
            class: "preview"
          }, [
            _createElementVNode("img", { src: _ctx.preview }, null, 8, _hoisted_8),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.preview = null), ["stop","prevent"]))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Modifica",
                text: "Modifica"
              })
            ])
          ], 8, _hoisted_7)),
      (_ctx.fileToUpload)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.uploadVideo && _ctx.uploadVideo(...args))),
              disabled: _ctx.loadingVideo
            }, [
              (!_ctx.loadingVideo)
                ? (_openBlock(), _createBlock(_component_localized_text, {
                    key: 0,
                    localizedKey: "Carica su server",
                    text: "Carica su server"
                  }))
                : (_openBlock(), _createBlock(_component_localized_text, {
                    key: 1,
                    localizedKey: "Attendi per favore",
                    text: "Attendi per favore"
                  }))
            ], 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Url del video",
          text: "Url del video"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.content.url) = $event))
      }, null, 512), [
        [_vModelText, _ctx.content.url]
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("label", _hoisted_13, [
        _createVNode(_component_localized_text, {
          localizedKey: "Parte testuale",
          text: "Parte testuale"
        })
      ]),
      _createVNode(_component_tiny_editor, {
        modelValue: _ctx.content.textContent,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.content.textContent) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-danger",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.annulla && _ctx.annulla(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Annulla modifiche e chiudi",
          text: "Annulla modifiche e chiudi"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-success",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Ok e chiudi",
          text: "Ok e chiudi"
        })
      ])
    ])
  ]))
}